import React from 'react'
import EditDisclaimerForm from './EditDisclaimerForm'

const EditDisclaimer = () => {
    return (
        <div>
            <EditDisclaimerForm/>
        </div>
    )
}

export default EditDisclaimer